/** Redis-stream style ids (`<ms>-<seq>`), ordered numerically on both halves. */
export const compareStreamIds = (a: string, b: string): number => {
  const [aMsRaw, aSeqRaw] = a.split('-');
  const [bMsRaw, bSeqRaw] = b.split('-');
  const aMs = Number(aMsRaw);
  const bMs = Number(bMsRaw);
  if (aMs !== bMs) return aMs - bMs;
  return Number(aSeqRaw ?? 0) - Number(bSeqRaw ?? 0);
};

/** Display/timing only — never a sort key. */
export const streamIdToMs = (id: string): number | undefined => {
  const raw = id.split('-')[0];
  if (!raw) return undefined;
  const ms = Number(raw);
  if (!Number.isFinite(ms) || ms < 0) return undefined;
  return ms;
};
